import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/containerTransportOrder/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/containerTransportOrder',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/containerTransportOrder',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/containerTransportOrder/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/containerTransportOrder',
    method: 'get',
    params: {
      id
    }
  })
}

export function maxSort(ladingOrderId) {
  return request({
    url: '/api/business/containerTransportOrder/maxSort',
    method: 'get',
    params: {
      ladingOrderId
    }
  })
}

export function detail(id) {
  return request({
    url: '/api/business/containerTransportOrder/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export function listTransportInfo(params) {
  return request({
    url: '/api/business/containerTransportOrder/listTransportInfo',
    method: 'get',
    params
  })
}
